import {
  Box,
  Heading,
  Icon,
  SimpleGrid,
  Text,
  useBreakpointValue,
  VStack,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdContentCopy, MdKey, MdAccountBalance, MdStar } from 'react-icons/md';
import WithdrawPix from '../withdrawals/components/WithdrawPix';
import CreatePaymentQrcode from '../withdrawals/components/PaymentQRcode';
import CreateWithdrawel from '../withdrawals/components/CreateWithdrawel';
import CreateFavored from '../withdrawals/components/CreateFavored';
import { queryClient } from 'index';

type PixMethod = 'DICT' | 'QRCODE' | 'MANU' | 'FAVORED' | null;

const methods = [
  {
    type: 'DICT' as const,
    title: 'Chave Pix',
    description: 'Envie usando CPF, e-mail, telefone ou chave aleatória',
    icon: MdKey,
    color: 'brand.500',
    iconColor: 'onBrand',
  },
  {
    type: 'QRCODE' as const,
    title: 'Copia e Cola',
    description: 'Cole o código Pix para realizar o pagamento',
    icon: MdContentCopy,
    color: 'green.500',
  },
  {
    type: 'MANU' as const,
    title: 'Dados Bancários',
    description: 'Transfira informando agência, conta e banco',
    icon: MdAccountBalance,
    color: 'blue.500',
  },
  {
    type: 'FAVORED' as const,
    title: 'Favoritos',
    description: 'Envie para contas salvas anteriormente',
    icon: MdStar,
    color: 'yellow.500',
  },
];

export default function PixPayment() {
  const navigate = useNavigate();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [selectedMethod, setSelectedMethod] = useState<PixMethod>(null);

  const handleSelect = (type: PixMethod) => {
    if (isMobile) {
      navigate(`/access/pix/${type?.toLowerCase()}`);
    } else {
      setSelectedMethod(type);
    }
  };

  const onClose = () => {
    setSelectedMethod(null);
    queryClient.refetchQueries({
      queryKey: ['findAllWithdrawers'],
      type: 'active',
    });
    navigate('/access/saques');
  };

  return (
    <Box>
      <Heading size="md" mb={6}>
        Pagamento Pix
      </Heading>

      <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={4}>
        {methods.map((method) => (
          <Card
            key={method.type}
            p={6}
            cursor="pointer"
            _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }}
            transition="all 0.2s"
            onClick={() => handleSelect(method.type)}
          >
            <VStack spacing={3} align="center" textAlign="center">
              <Box
                p={3}
                borderRadius="full"
                bg={method.color}
                color={method.iconColor ?? 'white'}
              >
                <Icon as={method.icon} boxSize={6} />
              </Box>
              <Text fontWeight="bold" fontSize="md">
                {method.title}
              </Text>
              <Text fontSize="sm" color="gray.500">
                {method.description}
              </Text>
            </VStack>
          </Card>
        ))}
      </SimpleGrid>

      {selectedMethod === 'DICT' && <WithdrawPix onClose={onClose} />}
      {selectedMethod === 'QRCODE' && <CreatePaymentQrcode onClose={onClose} />}
      {selectedMethod === 'MANU' && <CreateWithdrawel onClose={onClose} />}
      {selectedMethod === 'FAVORED' && <CreateFavored onClose={onClose} />}
    </Box>
  );
}
